const empty = (str) => {
  return (!str || str.length === 0);
};

class Address {
  constructor() {
    this.init();
  }

  init() {
    this.street_address_1 = '';
    this.street_address_2 = '';
    this.city = '';
    this.state = '';
    this.postal_code = '';
    this.country = '';
  }

  copy() {
    const cp = new Address();

    cp.street_address_1 = this.street_address_1;
    cp.street_address_2 = this.street_address_2;
    cp.city = this.city;
    cp.state = this.state;
    cp.postal_code = this.postal_code;
    cp.country = this.country;

    return cp;
  }

  equals(address) {
    return (!!address &&
      ((empty(address.street_address_1) && empty(this.street_address_1)) || (address.street_address_1 === this.street_address_1)) &&
      ((empty(address.street_address_2) && empty(this.street_address_2)) || (address.street_address_2 === this.street_address_2)) &&
      ((empty(address.city) && empty(this.city)) || (address.city === this.city)) &&
      ((empty(address.state) && empty(this.state)) || (address.state === this.state)) &&
      ((empty(address.postal_code) && empty(this.postal_code)) || (address.postal_code === this.postal_code)) &&
      ((empty(address.country) && empty(this.country)) || (address.country === this.country)));
  }

  isEmpty() {
    return empty(this.street_address_1) && empty(this.street_address_2) && empty(this.city)
      && empty(this.state) && empty(this.postal_code) && empty(this.country);
  }

  buildFromJSON(obj) {
    this.init();
    if (obj) {
      this.street_address_1 = obj.street_address_1 ? obj.street_address_1 : '';
      this.street_address_2 = obj.street_address_2 ? obj.street_address_2 : '';
      this.city = obj.city ? obj.city : '';
      this.state = obj.state ? obj.state : '';
      this.postal_code = obj.postal_code ? obj.postal_code : '';
      this.country = obj.country ? obj.country : '';
    }
  }

  toString() {
    let result;

    result = this.street_address_1;
    if (this.street_address_2) {
      result += ` ${this.street_address_2}`;
    }
    if (this.city || this.state || this.postal_code) {
      let cityLine = this.city;

      if (this.state) {
        cityLine = (cityLine.length) ? `${cityLine}, ${this.state}` : this.state;
      }
      if (this.postal_code) {
        cityLine = (cityLine.length) ? `${cityLine} ${this.postal_code}` : this.postal_code;
      }
      result = (result.length) ? `${result}, ${cityLine}` : cityLine;
    }

    return result;
  }

  getStreetAddress1() {
    return this.street_address_1;
  }

  setStreetAddress1(street) {
    this.street_address_1 = street;
  }

  getStreetAddress2() {
    return this.street_address_2;
  }

  setStreetAddress2(street) {
    this.street_address_2 = street;
  }

  getCity() {
    return this.city;
  }

  setCity(city) {
    this.city = city;
  }

  getState() {
    return this.state;
  }

  setState(state) {
    this.state = state;
  }

  getCountry() {
    return this.country;
  }

  setCountry(country) {
    this.country = country;
  }

  getPostalCode() {
    return this.postal_code;
  }

  setPostalCode(zip) {
    this.postal_code = zip;
  }
}

module.exports = Address;
